module.exports = __webpack_public_path__ + "static/media/lens_classic-Accent.02a5c888.png";